import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useNotice(noticeId: string) {
  const { pop } = useFlow();
  const { data, status } = useQuery(queries.notice.detail(noticeId));
  const toast = useToast();
  useEffect(() => {
    if (status === 'error') {
      toast.error('공지사항을 불러오지 못했습니다.');
      pop();
    }
  }, [status]);
  return data;
}

export default useNotice;
